import { computed } from 'vue'
import { resetServerConfig, useServerConfig } from '@/composables/useServerConfig'

/**
 * The unified-inbox feature flag — a typed view over the server config.
 * ===========================================================================
 * `new_inbox` decides whether lead-agency users get the unified inbox in place
 * of the old Text-Messages / Follow-Ups pages. It rides `useServerConfig` (Sandy
 * 2026-08-21), which loads every public setting in ONE call: the flag is read on
 * every navigation by the route middleware, so a query per feature would have
 * meant several round-trips before the first page could draw.
 *
 * (Was three flags while the V2 generation rolled out; the two V2 flags were
 * retired 2026-09-28 — `new_inbox` is the surviving switch.)
 *
 * Defaults to FALSE, the safe end: an unreachable API leaves everyone on the V1
 * pages rather than on a half-loaded new one.
 */

const KEYS = {
  newInbox: 'new_inbox',
}

/** Wipe on logout so the next user re-reads the flags. */
export function resetInboxFlags() {
  resetServerConfig()
}

export function useInboxFlags() {
  const config = useServerConfig()

  const flag = key => computed(() => config.getBool(KEYS[key], false))

  return {
    flags: computed(() => ({
      newInbox: config.getBool(KEYS.newInbox, false),
    })),
    loaded: config.loaded,
    newInbox: flag('newInbox'),
    load: config.load,
    reload: config.reload,
  }
}
